import { Modal } from 'antd'

import { DocTemplateForm } from './doc-template-form'
import styles from './doc-template-preview-dialog.module.scss'

type Props = {
  isVisible: boolean
  onClose: () => void
  patientId: number
  encounterUid: string
  templateId: number
  title?: string
  onSubmitSuccess?: () => void
}

export const DocTemplatePreviewDialog = ({
  isVisible,
  onClose,
  patientId,
  encounterUid,
  templateId,
  title = 'Document Preview',
  onSubmitSuccess,
}: Props) => {
  const handleSubmitSuccess = () => {
    onSubmitSuccess?.()
    onClose()
  }

  return (
    <Modal
      classNames={{
        content: styles.modalContent,
        wrapper: styles.modalWrapper,
        body: styles.modalBody,
      }}
      closeIcon={null}
      open={isVisible}
      onCancel={onClose}
      maskClosable={false}
      keyboard={false}
      title={null}
      destroyOnHidden
      footer={null}
      style={{ top: 20 }}>
      {isVisible && (
        <DocTemplateForm
          patientId={patientId}
          encounterUid={encounterUid}
          templateId={templateId}
          title={title}
          onSubmitSuccess={handleSubmitSuccess}
          onCancel={onClose}
        />
      )}
    </Modal>
  )
}
